import moment from "moment-timezone";
import Decimal from "decimal.js";
import { useState, useMemo } from "react";
import { AlertTriangle } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { BirthdayFundRequest, ListRequestsResponse } from "@/lib/api/fund";
import { CommonDestinationTimezone, formatCurrency, cn } from "@/lib/utils";
import { formatNumberToDisplay } from "@/lib/api/common";
import { DataTable, type DataTableColumn } from "@/components/ui/DataTable/index";
import { sum, sumDecimal } from "@/components/ui/DataTable/aggregation/index";
import { ResponsivePie } from "@nivo/pie";
import { StatsCard } from "./summaries/common";

// Typed wrappers so aggregationFn satisfies DataTableColumn's AggregationFn<OrgSummaryRow>
const sumAggregation = sum as any;
const sumDecimalAggregation = sumDecimal as any;


export function BirthdayFundSummary({ data }: { data: ListRequestsResponse }) {
  if (!data) return null;

  const { summaries } = data;
  const organizationSummaries = Object.entries(summaries.by_organization || {}).sort((a, b) =>
    Number(b[1].amount_granted.replace(/[^0-9.-]+/g, "")) - Number(a[1].amount_granted.replace(/[^0-9.-]+/g, ""))
  );

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
        <StatsCard
          title="Total Requested"
          value={summaries.total_requested_including_expired.toString()}
          description="Total fund requests, including expired"
          className="bg-blue-50"
        />
        <StatsCard
          title="Expired Requests"
          value={summaries.expired_total_count.toString()}
          description="Expired fund requests"
          className="bg-yellow-50"
        />
        <StatsCard
          title="Total Granted"
          value={summaries.total_granted.toString()}
          description="Approved fund requests"
          className="bg-green-50"
        />
        <StatsCard
          title="Amount Projected"
          value={formatCurrency(summaries.amount_projected)}
          description="Total funds projected"
          className="bg-purple-50"
          isCurrency
        />
        <StatsCard
          title="Amount Granted"
          value={formatCurrency(summaries.amount_granted)}
          description="Total funds disbursed"
          className="bg-purple-50"
          isCurrency
        />
      </div>
    </div>
  );
}


